import { SvgIcon } from '@material-ui/core'

export default function TalkbackIcon(props: any) {
    return (
        <SvgIcon viewBox="0 0 24 24" fill="none" {...props}>
            <path
                d="M22.2276 16.3926L17.3672 13.4308C17.114 13.2789 16.8102 13.4561 16.8102 13.7346L16.709 19.4051C16.709 19.7342 17.0887 19.8861 17.3165 19.6582L18.481 18.5697L19.848 21.0252C19.9493 21.2024 20.1771 21.2784 20.3543 21.1771L21.7719 20.3924C21.9492 20.2911 21.9998 20.0886 21.9238 19.9114L20.5568 17.4558L22.101 17.0508C22.4301 16.9749 22.4808 16.5698 22.2276 16.3926Z"
                fill="currentColor"
            />
            <path
                d="M21.4163 3H2.63274C1.1898 3 0 4.1898 0 5.63274V11.5817C0 13.05 1.1898 14.2145 2.63274 14.2145H15.6699V13.7335C15.6699 13.3284 15.7964 12.9487 16.0749 12.6703C16.3534 12.3918 16.7331 12.2146 17.1381 12.2146C17.4166 12.2146 17.6951 12.2905 17.9229 12.4424L20.7835 14.1891H21.3657C22.8086 14.1891 23.9984 12.9993 23.9984 11.5564V5.63274C24.0491 4.1898 22.8593 3 21.4163 3Z"
                fill="currentColor"
            />
        </SvgIcon>
    )
}
